import React from "react";

function HeightIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer rectangle */}
      <rect
        x="6"
        y="4"
        width="20"
        height="24"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      {/* Vertical double arrow for height */}
      <path
        d="M16 8L16 24M13 11L16 8L19 11M13 21L16 24L19 21"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeightIcon;
